import { Flex, Text } from "@chakra-ui/react";
import { SealCheckIcon } from "../../icons/SealCheckIcon";
import { useTranslation } from "react-i18next";
import { useReleasePricingInfo } from "../../../hooks/useReleasePricingInfo";
import { Release, ReleasePricingType } from "../../../types";

export interface DiscountBannerProps {
  release: Release;
  isGold?: boolean;
  fontSize?: string;
  justifyContent?: string;
}

export function DiscountBanner({
  release,
  isGold = false,
  fontSize = "12px",
  justifyContent = "center",
}: DiscountBannerProps) {
  const { t } = useTranslation();
  const pricingInfo = useReleasePricingInfo(release);

  let discount: number | null = null;

  switch (pricingInfo.type) {
    case ReleasePricingType.GoldDiscount:
    case ReleasePricingType.AvailableGoldDiscount:
      if (pricingInfo.goldPrice && pricingInfo.regularPrice) {
        discount = Math.round(
          ((pricingInfo.regularPrice - pricingInfo?.goldPrice) /
            pricingInfo.regularPrice) *
            100,
        );
      }
      break;
    case ReleasePricingType.RegularWithAvailableOnGoldSale:
    case ReleasePricingType.OnGoldSale:
      if (pricingInfo.goldSalePrice && pricingInfo.regularPrice) {
        discount = Math.round(
          ((pricingInfo.regularPrice - pricingInfo?.goldSalePrice) /
            pricingInfo.regularPrice) *
            100,
        );
      }
      break;
    default:
      discount = null;
  }

  if (!discount) return null;

  return (
    <Flex
      flexDirection="row"
      gap="8px"
      alignItems="center"
      width="100%"
      justifyContent={justifyContent}
    >
      <SealCheckIcon boxSize="24px" color="blaze.blaze" />
      <Text
        fontFamily="Roboto"
        fontWeight="500"
        fontSize={fontSize}
        lineHeight="150%"
        color="neutral.400"
      >
        {isGold
          ? t("components.slideInMenu.releaseInfoMenu.youSavedAsAGoldMember", {
              discount,
            })
          : t("components.slideInMenu.releaseInfoMenu.getWithAGoldMembership", {
              discount,
            })}
      </Text>
    </Flex>
  );
}
